import { z } from 'zod';

/**
 * This type is a representation of `JupiterDBTypes['PaypalSubscription']`.
 * IMPORTANT: we don't import the `JupiterDBTypes['PaypalSubscription']` type directly
 * because we do not want to add a `jupiter-db` dependency to the common contracts.
 */
export const PayPalSubscription = z.object({
  id: z.string(),
  userId: z.string(),
  paypalSubscriptionId: z.string(),
  productId: z.string(),
  entitlement: z.string(),
  isActive: z.boolean(),
  autoRenew: z.boolean(),
  expiresAt: z.string(),
  updatedAt: z.string(),
  createdAt: z.string(),
});

export type PayPalSubscription = z.infer<typeof PayPalSubscription>;
